import React from 'react';
import { Route } from 'react-router-dom';

import HairLandingPage from './pages/LandingPage';
import HairUploadModePage from './pages/UploadModePage';
import HairCapturePage from './pages/HairCapturePage';
import HairAIHairAnalysisPage from './pages/AIHairAnalysisPage';
import HairReportPage from './pages/HairReportPage/HairReportPage';
import HairProductRecommendationsPage from './pages/ProductRecommendationsPage';
import HairInsightWideCapture from './pages/HairInsight/HairInsightWideCapture';
import HairInsightMicroscopeCapture from './pages/HairInsight/HairInsightMicroscopeCapture';
import HairInsightAnalyzing from './pages/HairInsight/HairInsightAnalyzing';
import HairInsightDashboard from './pages/HairInsight/HairInsightDashboard';

/** Nested routes under `/hair` — used by main SPA and standalone hair-analyzer app. */
export function renderHairAnalyzerRoutes() {
  return (
    <>
      <Route index element={<HairLandingPage />} />
      <Route path="landing" element={<HairLandingPage />} />
      <Route path="session/:token" element={<HairLandingPage />} />
      <Route path="user-info" element={<HairUploadModePage />} />
      <Route path="upload-mode" element={<HairUploadModePage />} />
      <Route path="insight/capture" element={<HairInsightWideCapture />} />
      <Route path="insight/microscope" element={<HairInsightMicroscopeCapture />} />
      <Route path="insight/analyzing" element={<HairInsightAnalyzing />} />
      <Route path="insight/dashboard" element={<HairInsightDashboard />} />
      <Route path="capture" element={<HairCapturePage />} />
      <Route path="hair-analysis" element={<HairAIHairAnalysisPage />} />
      <Route path="hair-report" element={<HairReportPage />} />
      <Route path="hair-results" element={<HairReportPage />} />
      <Route path="hair-routine" element={<HairReportPage />} />
      <Route path="product-recommendations" element={<HairProductRecommendationsPage />} />
    </>
  );
}
